import { createSlice } from "@reduxjs/toolkit"
import { DropdownObj } from "pages/Common/commonTypes"

type DropdownOption = { id: string; title: string }

type ItemMasterFilters = {
    product_type: DropdownOption | null
    category: DropdownOption | null
    is_charger: DropdownObj | null
    tracking_type : DropdownOption | null
    status : DropdownOption | null
    search_key : string
}

type InitialState = {
    page: number
    selectedValue: number
    visibleColumns: { name: string; visible: boolean }[]
    itemFilters : ItemMasterFilters
}

const initialState: InitialState = {
    page: 1,
    selectedValue: 10,
    visibleColumns: [
        { name: "OPS SKU", visible: false },
        { name: "Charger Type", visible: false },
        { name: "OEM Name", visible: false },
        { name: "HSN/SAC Code", visible: false },
        { name: "Tracking Type", visible: false },
        { name: "Purchase Price", visible: false },
        { name: "Sales Price", visible: false },
    ],
    itemFilters : {
        product_type : null,
        category  : null,
        is_charger : null,
        tracking_type : null,
        status : null,
        search_key : ""
    }
}

const ItemMasterSlice = createSlice({
    name: "itemMaster",
    initialState,
    reducers: {
        setVisibleColumns(state, action) {
            state.visibleColumns = action?.payload
        },
        setItemFilters(state,action) {
            state.itemFilters = action.payload
        },
        setPage(state,action){
            state.page = action.payload
        },
        setSelectedValue(state,action){
            state.selectedValue = action.payload
        }
    },
})

export const { setVisibleColumns,setItemFilters,setPage,setSelectedValue } = ItemMasterSlice.actions
export default ItemMasterSlice.reducer
